<template>
  <section id="all-results-listing" class="all-cases-view">
    <div class="container-default">
      <!-- Primary-inner-navbar -->
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="7">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li>
                <el-button
                  class="btn button-with-icon"
                  @click="dialogVisible = true"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/upload-file.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/upload-file-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span>NEW BULK UPLOAD</span>
                </el-button>
              </li>
            </ul>
          </el-col>
          <el-col :lg="17">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15"
            >
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Search"
                    v-model="search_string"
                    @input="getAutoCompleteAccessions()"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllBulkAccessions.data"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              fixed="left"
              prop="file_name"
              label="FILE NAME"
              min-width="250"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession">
                  <div class="d-flex">
                    <span
                      id="file-name"
                      class="table_cell-ellipsis cursor ml-5"
                    >
                      {{ scope.row.file_name }}
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="STATUS"
              min-width="120"
              prop="status"
              sortable="custom"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-tag :type="getStatusType(scope.row.status)">{{
                    scope.row.status
                  }}</el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="PROGRESS"
              width="180"
              prop="status"
              sortable="custom"
            >
              <template #default="scope">
                <div class="progress-btn">
                  <el-button
                    type="text"
                    class="view-progress-btn"
                    @click="viewAccession(scope.row)"
                    >View Progress</el-button
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="updated_at"
              label="UPDATED ON"
              width="180"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.updated_at" class="d-flex">
                  <div class="date pr-10">
                    {{ momentWithTimezone(scope.row.updated_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="CREATE ACCESSIONS"
              width="200"
              prop="status"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-button
                    class="btn-active"
                    :type="getStatusType(scope.row.status)"
                    @click="startAccession(scope.row)"
                    :disabled="scope.row.status == 'COMPLETE'"
                    >START</el-button
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="action" label="Actions" width="100">
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button
                      class="view-button"
                      @click="downloadFile(scope.row)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-new.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      class="view-button"
                      @click="onDeleteBulkAccession(scope.row)"
                      :disabled="scope.row.status == 'COMPLETE'"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[10, 25, 50, 100]"
            :small="small"
            :disabled="disabled"
            :background="background"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getAllBulkAccessions.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <!-- modal for adding files in folders -->
    <div class="default-modal">
      <el-dialog v-model="dialogVisible" width="35%" :close="handleClose">
        <div class="dialog-header">
          <span class="header-part"> ADD FILE </span>

          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="handleDialogVisible"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
          </el-button>
        </div>
        <span>
          <el-form>
            <el-row :gutter="20" class="popup-date pb-0">
              <el-col :span="24">
                <div class="upload-files-alignment-block">
                  <div class="upload-files-alignment">
                    <el-upload
                      class="upload-demo"
                      drag
                      action
                      :on-change="handleUpload"
                      :on-remove="handleRemove"
                      :auto-upload="false"
                      :file-list="files"
                      accept=".csv"
                      :show-file-list="false"
                      :limit="1"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload-text-align">
                        <div class="el-upload__text-img">
                          <img
                            src="@/assets/images/icons/attachments-icon.svg"
                            alt=""
                          />
                        </div>
                        <div class="el-upload__text">
                          <h3>Drag & drop file here</h3>
                          <p>your file here, or browse</p>
                        </div>
                      </div>
                    </el-upload>
                  </div>
                  <div class="sample-attachment-upload-file-block">
                    <div v-for="(file, index) in files" :key="index">
                      <ul class="sample-attachment-upload-file">
                        <li>
                          <div class="file-name-attachment mb-10">
                            <img
                              src="@/assets/images/icons/attachments/attachments_1.svg"
                              alt=""
                            />
                            <p>{{ file.name }}</p>
                            <el-button
                              type="text"
                              @click="remove(index)"
                              class="btn-close"
                              size="sm"
                            >
                              <img
                                class="hover"
                                src="@/assets/images/icons/attachments/attachment-success.svg"
                                alt=""
                              />
                              <img
                                src="@/assets/images/icons/attachments/remove-button.svg"
                                alt=""
                                class="without-hover"
                              />
                            </el-button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="upload-files-alignment">
                  <div class="dialog-footer pt-0">
                    <el-button
                      class="blue-save-button"
                      @click="submitFileUploadDetails"
                      :disabled="hasBulkAccessionFiles"
                      :loading="uploadLoading"
                    >
                      <img
                        src="@/assets/images/icons/lab-documents/upload-icon-active.svg"
                        alt="icon"
                      />
                      UPLOAD
                      <span class="el-icon-upload2 submit-btn-arrow"></span>
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </span>
      </el-dialog>
    </div>
    <ResonForChange
      v-if="bulkAccessionRemoveDialog"
      v-on:close="bulkAccessionRemoveDialog = false"
      v-on:reasonSubmit="deleteBulkAccession"
      title="Reason for Delete"
    ></ResonForChange>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import FilterHelper from "@/mixins/FilterHelper";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "allBulkAccession",
  mixins: [FilterHelper],
  components: {
    ResonForChange,
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  data() {
    return {
      bulkAccessionRemoveDialog: false,
      page: 1,
      pageSize: 25,
      loading: false,
      orderBy: "created_at",
      orderType: "DESC",
      caseType: "",
      searchBy: "",

      modalLoading: false,
      uploadLoading: false,
      dialogVisible: false,
      search_string: "",
      files: [],
      bulkAccessionId: "",
    };
  },
  computed: {
    hasBulkAccessionFiles() {
      if (this.files && this.files.length) {
        return false;
      }
      return true;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "PROCESSING") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("bulkAccessions", [
      "getAllBulkAccessions",
      "getBulkAccessionUploadFileStatus",
      "getStartBulkAccessionStatus",
      "getBulkAccessionDeleteStatus",
      "getBulkAccessionDownload",
    ]),
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
  },
  mounted() {
    this.setQueryParamsData();
    this.fetchAllBulkAccessions();
  },

  methods: {
    handleDialogVisible() {
      this.dialogVisible = false;
      this.files = [];
    },
    async startAccession(bulkAccession) {
      try {
        this.loading = true;
        let params = {
          bulk_accession_id: bulkAccession._id,
        };
        await this.$store.dispatch("bulkAccessions/startBulkAccession", params);
        if (this.getStartBulkAccessionStatus) {
          successNotification("Accession created successfully");
          this.fetchAllBulkAccessions();
        } else {
          errorNotification("Error at Creating Accession");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    remove(index) {
      this.$confirm("Are you sure want to DELETE File. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        await this.files.splice(index, 1);
      });
    },
    getAutoCompleteAccessions() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllBulkAccessions();
      }, 600);
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedBulkAccessionPage
        ? parseInt(this.$route.query.selectedBulkAccessionPage)
        : 1;
      this.pageSize = this.$route.query.selectedBulkAccessionPageSize
        ? parseInt(this.$route.query.selectedBulkAccessionPageSize)
        : 25;
      if (this.$route.query.selectedBulkAccessionOrderBy) {
        this.orderBy = this.$route.query.selectedBulkAccessionOrderBy;
      }
      if (this.$route.query.selectedBulkAccessionOrderType) {
        this.orderType = this.$route.query.selectedBulkAccessionOrderType;
      }
      if (this.$route.query.selectedBulkAccessionString) {
        this.search_string = this.$route.query.selectedBulkAccessionString;
      }
    },

    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllBulkAccessions();
    },

    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllBulkAccessions();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllBulkAccessions();
    },

    async downloadFile(doc) {
      let params = {
        bulk_accession_id: doc._id,
      };
      await this.$store.dispatch(
        "bulkAccessions/downloadBulkAccession",
        params
      );

      let url = this.getBulkAccessionDownload.download_url;
      window.open(url, "_blank");
    },

    onDeleteBulkAccession(bulkAccession) {
      this.bulkAccessionId = bulkAccession;
      this.bulkAccessionRemoveDialog = true;
    },

    async deleteBulkAccession() {
      try {
        this.loading = true;
        let params = {
          bulk_accession_id: this.bulkAccessionId._id,
        };
        await this.$store.dispatch(
          "bulkAccessions/deleteBulkAccession",
          params
        );

        if (this.getBulkAccessionDeleteStatus) {
          successNotification("Bulk accession deleted successfully");
        } else {
          errorNotification("Error at deleting bulk accession");
        }
        this.page = 1;
        this.fetchAllBulkAccessions();
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async viewAccession(bulkAccession) {
      this.$router.push({
        name: "BulkAccessionsInfo",
        params: {
          bulk_accession_id: bulkAccession._id,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedBulkAccessionPage: params.page,
        selectedBulkAccessionPageSize: params.limit,
        selectedBulkAccessionOrderBy: params.order_by,
        selectedBulkAccessionOrderType: params.order_type,
        selectedBulkAccessionString: params.search_string,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      params.status = this.selectedStatuses;
      return params;
    },
    async fetchAllBulkAccessions() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch(
          "bulkAccessions/fetchAllBulkAccessions",
          params
        );
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleClose() {
      this.files = [];
      this.dialogVisible = false;
    },
    handleRemove() {
      this.files = [];
    },
    handleUpload(file) {
      file.status = "success";
      file.percentage = 100;
      this.files = [];
      this.files.push(file);
    },
    async submitFileUploadDetails() {
      try {
        this.uploadLoading = true;
        let data = new FormData();
        data.append("case_csv", this.files[0].raw);
        await this.$store.dispatch(
          "bulkAccessions/saveBulkAccessionFiles",
          data
        );
        if (this.getBulkAccessionUploadFileStatus) {
          successNotification("File uploaded successfully");
          this.dialogVisible = false;
          this.files = [];
          this.fetchAllBulkAccessions();
        } else {
          errorNotification("Error in uploading file");
        }
        this.uploadLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
#all-results-listing {
  .btn-active {
    border-radius: 4px !important;
    padding: 6px 5px;
    height: auto;
    min-height: 20px;
    line-height: 1;
    min-width: 100px;
    font-weight: 500 !important;
    text-align: center;
    font-size: 12px !important;
    background: #f2f2f2;
    border: 0.6px solid #5162fd;
    color: #5162fd;
    &:hover,
    &:active,
    &:focus {
      background: #ffffff;
      border: 0.6px solid #5162fd;
      color: #5162fd;
    }
    &.is-disabled {
      opacity: 0.5;
      background: #f2f2f2;
      border: 0.6px solid #5162fd;
      color: #5162fd;
      &:hover {
        opacity: 0.5;
        background: #f2f2f2;
        border: 0.6px solid #5162fd;
        color: #5162fd;
      }
    }
  }
  .order-files {
    img {
      position: relative;
      top: 3px;
      right: 4px;
    }
  }
  .progress-btn {
    .el-button {
      min-height: 0;
      padding: 0;
      color: #5162fd;
      font-size: 14px;
      font-weight: 500;
      &.generate-btn {
        color: green;
      }
      &.process-btn {
        color: #f28b0c;
      }
    }
  }
  .default-modal {
    .popup-date {
      .el-upload {
        width: 100%;
      }
      .el-upload-dragger {
        width: 100%;
        height: 120px;
        margin: auto;
        background: #c4c4c41f;
        border: 0.6px dashed #c4c4c41f;
        border-radius: 6px;
      }
      .el-upload-text-align {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        .el-upload__text-img {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            padding: 0 10px;
          }
        }
        .el-upload-text {
          line-height: 14px;
          h3 {
            color: #333;
            font-size: 18px;
          }
          p {
            color: #828282;
            font-size: 18px;
          }
        }
      }
    }
  }
  .upload-files-alignment-block {
    .upload-files-alignment {
      width: 100%;
      margin: auto;
      margin-bottom: 10px;
    }
    .sample-attachment-upload-file-block {
      .sample-attachment-upload-file {
        li {
          .file-name-attachment {
            display: inline-flex;
            align-items: center;
            min-width: 30%;
            max-width: 96%;
            height: 20px;
            padding: 7px 5px 7px 0;
            margin: 0;
            border: 0.5px solid #e0e0e0;
            border-radius: 5px;
            img {
              width: 15px;
              height: 15px;
              padding: 0 10px;
            }
            p {
              overflow: hidden;
              width: 100%;
              color: #4f4f4f;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .el-button {
              .without-hover {
                display: none;
                transition: all 0.2s ease-in-out;
              }
              .hover {
                display: block;
                transition: all 0.2s ease-in-out;
              }
              &:hover {
                .without-hover {
                  display: block;
                  transition: all 0.2s ease-in-out;
                }
                .hover {
                  display: none;
                  transition: all 0.2s ease-in-out;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
